import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <h4 className="contactus">
        Contact us:{" "}
        <span className="email">myappsandworks@gmail.com</span>
      </h4>
    </footer>
  );
};

export default Footer;
